import EventEmitter from 'events';
import {
  OPEN_CONFIRM_MODAL,
  CLOSE_CONFIRM_MODAL,
  CONFIRM_MODAL_CONFIRM,
  CONFIRM_MODAL_NEGATIVE,
} from './constants';

const confirmModal = (params, confirmCallback, negativeCallback, closeCallback) => {
  EventEmitter.prototype.emit(OPEN_CONFIRM_MODAL, params);

  return new Promise((resolve) => {
    EventEmitter.prototype.once(CONFIRM_MODAL_CONFIRM, () => {
      resolve(true);
      if (confirmCallback) {
        confirmCallback();
      }
    });

    EventEmitter.prototype.once(CONFIRM_MODAL_NEGATIVE, () => {
      resolve(false);
      if (negativeCallback) {
        negativeCallback();
      }
    });

    EventEmitter.prototype.once(CLOSE_CONFIRM_MODAL, () => {
      resolve(false);
      if (closeCallback) {
        closeCallback();
      } else if (negativeCallback) {
        negativeCallback();
      }
    });
  });
};

export default confirmModal;
